import mutations from './gdprPerson.mutations'
import actions from './gdprPerson.actions'
import getters from './gdprPerson.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
